import React, { createContext, useState, useContext, useEffect } from "react";
import api from "../Services/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem("accessToken-house");
    const storedUser = localStorage.getItem("user");

    if (storedToken && storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = async (loginId, password) => {
    try {
      const response = await api.post("auth/house/login", {
        loginId,
        password,
      });

      if (response.data) {
        const { access_token, refresh_token, user: userData } = response.data;
        localStorage.setItem("accessToken-house", access_token);
        localStorage.setItem("refreshToken-house", refresh_token);
        localStorage.setItem("user", JSON.stringify(userData));
        setUser(userData);
        return true;
      }
      return false;
    } catch (error) {
      console.error("Erro no login:", error);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem("accessToken-house");
    localStorage.removeItem("refreshToken-house");
    localStorage.removeItem("user");
    setUser(null);
  };

  const authContextValue = {
    user,
    isLoggedIn: !!user,
    login,
    logout,
  };

  if (loading) {
    return null;
  }

  return (
    <AuthContext.Provider value={authContextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
